module.exports = __webpack_public_path__ + "img/logo.e7003df7.png";